<template>
<modal :show="show" class="signin-modal">
	<Loader :loading="loading" ref="loader"></Loader>
    <div class="modal-header">
	   	<button v-if="$route.name=='licenses'" @click="goBack" type="button" class="back">
	        <i class="icon icon-arrow-left"></i>
	    </button>
        <button v-if="canClose" @click="close" type="button" class="close">
            <i class="icon icon-close"></i>
        </button>
    </div>

    <div class="modal-body">

    	<div v-if="defaultSignin" class="default-signin">
     		<h1>SOS List Account</h1>

       		<div class="buttons">
	       		<!-- <a href="/api/oauth/google/redirect">
	         		<i class="icon icon-checkbox-checked"></i>
	         		<span>Sign in with Google</span>
	            </a> -->
	        	<button @click="useEmail">
	         		<i class="icon icon-mail"></i>
	         		<span>Sign in with email</span>
	           	</button>
            </div>

            <span class="purchase"><router-link @click.native="close" :to="{ name: 'pricing' }">Purchase license</router-link> to create an account</span>


        </div>

    	<div v-if="emailSignin" class="email-signin">
     		<h1>Sign in with email</h1>
       		<p>Enter the email address associated with your account, and we’ll send a magic link to your inbox.</p>

			<label>Your Email</label>
	        <input @keydown.enter="linkConfirm" v-model="email" autocapitalize="off">
			<span v-if="error">Email was not recognized</span>

			<button @click="linkConfirm" class="submit-button">
				Continue
			</button>

			<a @click="useDefault"><i class="icon icon-chevron-left"></i> Back</a>
		</div>

		<div v-if="emailConfirm" class="email-confirm">
			<h1>Check your email to sign in </h1>
       		<p>Click the link we sent to <b>{{email}}</b></p>
			<p>If it doesn't arrive in three minutes be sure to check your spam folder</p>

			<button @click="close" class="submit-button">
				Ok
			</button>

		</div>
	</div>


</modal>
</template>

<script>
import Modal from "@/../submodules/vue-base/components/Modal";
import Loader from "@/../submodules/vue-base/components/Loader";
import axios from "axios";
export default {

    name: 'RequestSigninModal',

    components: {
        Modal,
		Loader
    },

	props: {
		next: "",
		canClose: {
			type:Boolean,
			default: true
		},
	},

    data(){
        return {
            show:false,
			loading: false,
			error:false,
			email: "",
			defaultSignin: true,
			emailSignin: false,
			emailConfirm: false,
        }
    },

    methods: {
    	goBack(){
			window.location = "/";
     	},
        open(){
            this.show=true;
            this.defaultSignin = true;
			this.emailSignin = false;
			this.emailConfirm = false;
        },

        close(){
            this.show=false
            this.$emit("close")
        },

        useEmail(){
			this.defaultSignin = false;
			this.emailSignin = true;
			this.error = false;
			this.email = "";
        },

        useDefault(){
			this.defaultSignin = true;
			this.emailSignin = false;
        },

        linkConfirm() {

			this.loading = true;
			var temp = this;

			var obj = {
				email:this.email
			};

			if(this.next != ""){
				obj.next = this.next;
			}

			axios.post("/api/signin/user",obj).then(function(response){

				temp.loading=false;

				temp.emailSignin = false;
				temp.emailConfirm = true;

			}).catch(function(){

				temp.loading=false;
				temp.error=true;

			})


        }
    }

}
</script>
